import "./datatable.scss";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import {
  centerColumns,
  centerRows,
  fetchCenterRows,
} from "../../datatablesource";
import { Link } from "react-router-dom";
import { useState, useEffect } from "react";
import { useSlug } from "../../SlugContext";
import { serverUrl } from "../../temp";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css"; // Import Toastify CSS
import Loader from "../loader/Loader";

const CenterDatatable = () => {
  const [data, setData] = useState(centerRows);
  const [loading, setLoading] = useState(false);
  // const slugs = localStorage.getItem("slugs");
  const { slugs } = useSlug();
  console.log("slugs abbas", slugs);
  useEffect(() => {
    const getData = async () => {
      setLoading(true);
      const rows = await fetchCenterRows();
      console.log("jawad", rows);
      setLoading(false);
      setData(Array.from(rows.data));
    };
    getData();
  }, []);

  const handleDelete = (id) => {
    // Make a DELETE request to the Flask API endpoint
    fetch(`${serverUrl}/del_center/${id}`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        // Remove the item from your React data state if the API request is successful
        console.log(data);
        setData(data.filter((item) => item.id !== id));
        toast.success("Center deleted successfully!");
      })
      .catch((error) => {
        console.error("There was a problem with the fetch operation:", error);
        toast.error("An error occurred :.", error);
      });
  };
  const viewLinkString = "Center-Single";
  const editLinkString = "Center-Edit";
  const newLinkString = "Center-New";

  const actionColumn = [
    {
      field: "action",
      headerName: "Action",
      width: 200,
      renderCell: (params) => {
        return (
          <div className="cellAction">
            {slugs && slugs.includes(viewLinkString) && (
              <Link
                to={`/center/${params.row.id}`}
                style={{ textDecoration: "none" }}
              >
                <div className="viewButton">View</div>
              </Link>
            )}
            {slugs && slugs.includes(editLinkString) && (
              <Link
                to={`/center/update-center/${params.row.id}`}
                style={{ textDecoration: "none" }}
              >
                <div className="editButton">Edit</div>
              </Link>
            )}

            <div
              className="deleteButton disabled"
              onClick={() => handleDelete(params.row.id)}
            >
              Delete
            </div>
          </div>
        );
      },
    },
  ];
  return (
    <div className="datatable">
      <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between w-full gap-3 pb-2 lg:pb-2">
        <div className="text-gray-700 text-2xl">Center</div>
        <div className="flex flex-col sm:flex-row gap-2 w-full lg:w-auto">
          {slugs && slugs.includes(newLinkString) && (
            <Link to="/center/new" className="commonButton w-full sm:w-auto">
              Add New
            </Link>
          )}
        </div>
      </div>
      {loading ? (
        // <h1 style={{ textAlign: "center", paddingTop: "20%" }}>loading...</h1>
        <Loader fullScreen={false} />
      ) : (
        <DataGrid
          className="datagrid"
          rows={data}
          columns={centerColumns.concat(actionColumn)}
          pageSize={9}
          rowsPerPageOptions={[9]}
          components={{
            Toolbar: GridToolbar, // Include the GridToolbar in the Toolbar slot
          }}
          // checkboxSelection
        />
      )}
      <ToastContainer />{" "}
      {/* Add ToastContainer here to show the notifications */}
    </div>
  );
};

export default CenterDatatable;
